/*
 * decaffeinate suggestions:
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let key;
$(function() {});
// window.media =
// <% Consumer::Application.config.breakpoints.keys.each do |key| %>
//   <%= key %>: <%= key == :default %>
// <% end %>

// <% Consumer::Application.config.breakpoints.each do |key, value| %>
//     match: -> window.media.<%= key %> = true
//     unmatch: -> window.media.<%= key %> = false
// <% end %>

window.media =
    (() => {
        const result = [];
        for (key in window.breakpoints) {
            result.push({key: key === 'default'});
        }
        return result;
    })();

for (key in window.breakpoints) {
    const value = window.breakpoints[key];
    ({
        match() { return window.media.key = true; },
        unmatch() { return window.media.key = false; }
    });
}